const submit = (item, submission) => {
  submission.setState({ submitted: true });
};

export default submit;
